@if (formData) {
  <div class="gcontainer review-container" #reviewpage>
    @if (!IsjwtCustomerLogin) {
      <div class="r-header-wrapper">
        <div class="no-print">
          @if (userAccount) {
            <nav aria-label="breadcrumb" class="bredcrums">
              <ol class="breadcrumb">
                @if (fromWhere === 'd') {
                  <li class="breadcrumb-item active breadcrumb cursor" aria-current="page">
                    <a class="c-primary" [routerLink]="'/dashboard'" tabindex="0"> Dashboard </a>
                  </li>
                }
                @if (fromWhere === 'd') {
                  <li class="breadcrumb-item active" aria-current="page">
                    Review Form - @if (soilType === 'precast') {
                    <span>Pre Cast</span>
                  }
                  @if (soilType === 'nativesoil') {
                    <span>Native Soil</span>
                  }
                </li>
              }
              @if (fromWhere === 'w') {
                <li class="breadcrumb-item active breadcrumb cursor" aria-current="page">
                  <a class="c-primary" [routerLink]="'/dashboard'" tabindex="0"> Dashboard </a>
                </li>
              }
              @if (fromWhere === 'w') {
                <li class="breadcrumb-item active breadcrumb cursor" aria-current="page">
                  <a class="c-primary" (click)="gotoWorksheet()" tabindex="0" (keydown)="gotoWorksheet()">
                    {{ formData.company.name }} - {{ formData.project.projectName }} - Worksheet -
                    @if (soilType === 'precast') {
                      <span>Pre Cast</span>
                    }
                    @if (soilType === 'nativesoil') {
                      <span>Native Soil</span>
                    }
                  </a>
                </li>
              }
              @if (fromWhere === 'w') {
                <li class="breadcrumb-item active" aria-current="page">Review Form</li>
              }
            </ol>
          </nav>
        }
      </div>
      <div class="row">
        <div class="col-sm-10">
          <h1>@if (projectReference) {
            <span>{{ projectReference }} : </span>
          }{{ title }} </h1>
        </div>
        @if (!printSuccess && !projectId) {
          <h2 class="no-print c-primary">Please review the submission form</h2>
        }
        @if (showPrintSuccessMessage) {
          <h2 class="no-print h-success">Submission Successful</h2>
        }
      </div>
      <div class="row">
        <div class="col-12">
          <div class="manageProjects">
            <div class="row">
              <div class="col-md-4">
                @if (!IsjwtCustomerLogin) {
                  <div>
                    <app-customer-attachments class="customer-attachments"
                      (selectedAttachment)="selectedAttachment($event)"
                      [projectId]="projectId"
                      [backgroundClass]="'yellow'"
                      [showSuccess]="showPrintSuccessMessage"
                      style="vertical-align: middle; margin-right: 16px">
                    </app-customer-attachments>
                    @if (projectId) {
                      <div>
                        <mat-checkbox
                          color="primary"
                          [disabled]="instructionData.instructionsConfirmed === true"
                          [(ngModel)]="instructionsReceived">
                          Instruction confirmed
                        </mat-checkbox>
                      </div>
                    }
                  </div>
                }
                @if (IsjwtCustomerLogin) {
                  <div>
                    <app-jwt-customer-attachment (selectedAttachment)="selectedAttachment($event)"
                      [projectId]="projectId"
                      [backgroundClass]="'yellow'"
                      [showSuccess]="showPrintSuccessMessage"
                      style="vertical-align: middle; margin-right: 16px">
                    </app-jwt-customer-attachment>
                  </div>
                }
              </div>
              <div class="col-md-4 status-container">
                @if (formData.project.geothermField) {
                  <mat-chip class="chipset-green float-right">
                    <img src="./../../../assets/icons/pre-approval-tick.svg" class="icon-position" alt="Geo-Testing-Success" />
                    <span class="text-white chip-text">Geotherm Field Testing </span>
                  </mat-chip>
                }
                @if (formData.project.preApproval) {
                  <mat-chip class="chipset-blue float-right">
                    <img src="./../../../assets/icons/pre-approval-tick.svg" class="icon-position" alt="Rush-Testing-Warning" />
                    <span class="text-white chip-text"> Pre-Approval</span>
                  </mat-chip>
                }
                @if (formData.project.rushTesting) {
                  <mat-chip class="chipset-warning float-right">
                    <img src="./../../../assets/icons/rush-warning-icon.svg" class="icon-position" alt="Rush-Testing-Warning" />
                    <span class="chip-text"> Rush</span>
                  </mat-chip>
                }
              </div>
              @if (!IsjwtCustomerLogin) {
                <div class="col-md-4 right-fields">
                  <form [formGroup]="Inhouseform">
                    @if (isDueDateSet) {
                      <div class="due-date-container">
                        <mat-label  class="mat-label">Due Date</mat-label>
                        <mat-form-field appearance="outline" style="width: auto">
                          <input
                            matInput
                            (dateChange)="onDueDateChange()"
                            [matDatepicker]="picker"
                            formControlName="dueDate"
                            [min]="yesterday"
                            readonly />
                            <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                            <mat-datepicker #picker></mat-datepicker>
                          </mat-form-field>
                        </div>
                      }
                      @if (projectId && soilType === 'precast') {
                        <div class="sample-prefix-container">
                          <mat-label  class="mat-label">Sample Prefix</mat-label>
                          <mat-form-field class="prefix-field" appearance="outline" [ngClass]="{ 'disabled-form-field': disablePrefix }">
                            <input matInput formControlName="inHouseIdPrefix" (input)="onPrefixChange($event)" [readonly]="disablePrefix" appAlphabetic [maxLength]="2" />
                            @if (shouldShowSearchIcon()) {
                              <button mat-icon-button matSuffix class="search-icon" (click)="checkInhouseId()">
                                <img src="/assets/icons/commit.svg" alt="commit" />
                              </button>
                            }
                            @if (shouldShowDoneIcon()) {
                              <span matSuffix class="done-icon">
                                <img src="/assets/icons/checked.svg" alt="done" />
                              </span>
                            }
                          </mat-form-field>
                          @if (shouldShowError()) {
                            <span class="error"> Prefix Unavailable</span>
                          }
                        </div>
                      }
                    </form>
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    }
    <div class="row">
      <div class="re-content-wrapper">
        @if (companyInformation) {
          <app-company-contact-information
            [returnUrl]="fromWhere"
            [enableEditButton]="enableCompanyEdit | async"
            [data]="companyInformation"
            [billing]="billingInformation"
            [link]="editLink"
            [samples]="viewSubmissionInfo"
            [officeLocationName]="officeLocationName"
            (submitForm)="handleSubmitForm($event)"
          [panelOpen]="panelOpen | async"></app-company-contact-information>
        }
        <div class="spacer"></div>
        <app-sample-information
          [projectId] = "projectId"
          [returnUrl]="fromWhere"
          [enableEditButton]="enableSampleEdit | async"
          [link]="editLink"
          [title]="sampleTitle"
          [headerColumns]="headerColumns"
          [displayedColumns]="displayedColumns"
          [dataSource]="dataSource"
          [data]="companyInformation"
          [soilType]="soilType"
          [sampleViewInfo]="tableViewSubmission"
          (samplesChange)="handleSamplesChange($event)"
          [precastSampleTypes]="precastSampleTypes"
          [nativeSoilSampleTypes]="nativeSoilSampleTypes"
          (splitSamplesChange)="hanldeSplitProject($event)"
          (noCheckboxChecked)="handleNoCheckboxChecked($event)"
        (checkStatusTypeValue)="handleDisbabledbtn($event)"></app-sample-information>
        <div class="spacer"></div>
        @if (instructionData) {
          <app-instructions-sample-type
            [returnUrl]="fromWhere"
            [enableEditButton]="enableInstructionEdit | async"
            [link]="editLink"
            [title]="instructionTitle"
            [data]="instructionData"
            [Type]="soilType"
            [commentData]="viewSubmissionInfo"
            [companyData]="companyInformation"
            [precastSampleTypes]="precastSampleTypes"
            (submitForm)="handleComment($event)"
          ></app-instructions-sample-type>
        }
        <div class="spacer"></div>
        <div class="spacer"></div>
        @if (reviewEdit && !IsjwtCustomerLogin) {
          <div class="btn-wrapper">
            <div class="no-print btn-left">
              @if (cancelOrClose) {
                <button mat-raised-button (click)="close()">CLOSE</button>
              }
              @if ((enableSampleEdit && !cancelOrClose && !projectId) || (projectId && editViewSubmission)) {
                <button
                  mat-raised-button
                  (click)="onCancel()">
                  CANCEL
                </button>
              }
              @if (!enableSampleEdit) {
                <button mat-raised-button (click)="back()">BACK</button>
              }
            </div>
            <div class="no-print btn-container btn-right">
              @if (!projectId || (projectId && editViewSubmission)) {
                <button mat-raised-button (click)="print()">
                  <img src="/assets/icons/Print-red.svg" alt="print" />
                  PRINT
                </button>
              }
              @if ((showSubmitButton && !projectId) || (projectId && editViewSubmission)) {
                <button
                  class="edit-btn"
                  mat-raised-button
                  (click)="editSubmission()">
                  EDIT
                </button>
              }
              @if ((projectId && isFlagged) || (projectId && isSplitAction)) {
                <button
                  class="split-flag"
                  mat-raised-button
                  (click)="onFlagSplitCancel()">
                  CANCEL
                </button>
              }
              @if ((projectId && !editViewSubmission && roleCheck(['Admin', 'Manager',]) && !isSplitAction) ||
                (isFlagged && roleCheck(['Accounting']))) {
                <button
                  mat-raised-button
                  color="primary"
                  (click)="onSubmitWorksheet()">
                  SAVE
                </button>
              }
              @if (projectId && !editViewSubmission && roleCheck(['Admin', 'Manager', 'Reportwriter']) && isSplitAction) {
                <button
                  mat-raised-button
                  color="primary"
                  (click)="onSplitWorksheet()"
                  [disabled]="!isCheckboxChecked">
                  SPLIT
                </button>
              }
              @if ((showSubmitButton && !projectId) || (projectId && editViewSubmission)) {
                <button
                  [disabled]="!enableSubmitButton"
                  mat-raised-button
                  color="primary"
                  (click)="onSubmit()">
                  {{ submitText }}
                </button>
              }
              @if (projectId && !editViewSubmission && !isFlagged && !isSplitAction) {
                <button
                  [matMenuTriggerFor]="aboveMenu"
                  [disabled]="!enableSubmitButton"
                  mat-raised-button
                  color="primary">
                  ACTIONS
                </button>
              }
              <mat-menu class="dashboard-menu menu-border" #aboveMenu="matMenu" yPosition="below">
                @if (roleCheck(['Reportwriter', 'Admin', 'Manager','Accounting'])) {
                  <button mat-menu-item (click)="editSubmission()">
                    <span class="menu-text">
                      <img src="/assets/icons/Edit.svg" alt="File" />
                      Edit Submission Form
                    </span>
                  </button>
                }
                @if (!formData.project.worksheetGenerated && (!isMergeDisabled || !formData.project.worksheetGenerated)) {
                  <button
                    mat-menu-item (click)="splitAction(projectId, soilType)"
                    [disabled]="!splitEnabled || splitLength">
                    <span class="menu-text">
                      <img src="/assets/icons/Split.svg" alt="split-icon" />
                      Split Project
                    </span>
                  </button>
                }
                @if (roleCheck(['Admin', 'Manager','Accounting'])) {
                  <button
                    mat-menu-item
                    (click)="previewOpenDialog(projectId)"
                    [disabled]="enableMissingButton">
                    <span class="menu-text">
                      <img src="/assets/icons/Alert-3.svg" alt="Notification-icon" />
                      Notify Issues or Missing Data
                    </span>
                  </button>
                }
                @if (roleCheck(['Admin', 'Manager','Accounting'])) {
                  <button mat-menu-item
                    (click)="flagSubmission(projectId, soilType)">
                    <span class="menu-text">
                      <img src="/assets/icons/flag.svg" alt="Notification-icon" />
                      Flag Submission Information
                    </span>
                  </button>
                }
                @if (roleCheck(['Admin', 'Manager']) || (generateFlag && roleCheck(['Reportwriter']))) {
                  <button
                    mat-menu-item
                    (click)="viewGenerateSheet()"
                    [disabled]="(enableGenerateBtn || hasMissing)">
                    <span class="menu-text">
                      <img src="/assets/icons/Bar-Chart-2.svg" alt="Notification-icon" />
                      {{
                      !this.generateFlag || (companyInformation && !companyInformation.worksheetGenerated)
                      ? 'Generate Worksheet'
                      : 'View Worksheet'
                      }}
                    </span>
                  </button>
                }
              </mat-menu>
              @if (showPrintHints) {
                <p class="c-primary">
                  Please print this page first to be included with your sample shipment before submitting.
                </p>
              }
            </div>
            <div class="clear"></div>
          </div>
        }
        @if (IsjwtCustomerLogin ) {
          <div class="btn-wrapper">
            <div class="no-print btn-left">
              @if (cancelOrClose) {
                <button mat-raised-button (click)="onCustomerClose()">CLOSE</button>
              }
              @if (!cancelOrClose && projectId) {
                <button
                  mat-raised-button
                  (click)="onCustomerClose()">
                  Return to Dashboard
                </button>
              }
              @if (!cancelOrClose && !projectId) {
                <button
                  mat-raised-button
                  (click)="onCustomerCancel()">
                  CANCEL
                </button>
              }
              @if (!enableSampleEdit) {
                <button mat-raised-button (click)="back()">BACK</button>
              }
            </div>
            <div class="no-print btn-container btn-right">
              @if (!projectId) {
                <button mat-raised-button (click)="print()">
                  <img src="/assets/icons/Print-red.svg" alt="print" />
                  PRINT
                </button>
              }
              @if (!projectId && showSubmitButton ) {
                <button
                  class="edit-btn"
                  mat-raised-button
                  (click)="editSubmission()">
                  EDIT
                </button>
              }
              &nbsp;&nbsp;
              @if (!projectId && showSubmitButton) {
                <button
                  [disabled]="!enableSubmitButton"
                  mat-raised-button
                  color="primary"
                  (click)="onSubmit()">
                  {{ submitText }}
                </button>
              }
              @if (showPrintHints) {
                <p class="c-primary">
                  Please print this page first to be included with your sample shipment before submitting.
                </p>
              }
            </div>
            <div class="clear"></div>
          </div>
        }
      </div>
    </div>
  </div>
}
